import styled from 'styled-components';
import Modal from '../../../../../../../shared/modal';

export const ModalStyled = styled(Modal)`
  .modal-overlay {
    z-index: 10004;
  }

  .modal-wrapper {
    z-index: 10005;
  }
`;
